import { StoredTabManagerState, TabManagerStorateAdapter } from './types';

export class InMemoryTabManagerStorageAdapter
  implements TabManagerStorateAdapter
{
  notify(): void {
    //noop
  }
  subscribe(_: (s: StoredTabManagerState) => void): () => void {
    //noop

    return () => {
      //noop
    };
  }

  destroy(): void {
    //noop
  }
  private state: StoredTabManagerState = {
    activeTab: null,
    tabs: [],
  };

  getState() {
    return this.state;
  }

  setState(state: StoredTabManagerState) {
    this.state = state;
  }
}
